import React from "react";
import PropTypes from "prop-types";
import { useStoreState, useStoreActions } from "easy-peasy";
import { getSeconds } from "../../utils/timeUtils";

function SkipButton({ containerId, mobileResponsiveUtil }) {
  const { isSkipVisible: isVisible, player: videoPlayer } = useStoreState(
    (state) => state.stage
  );

  const { activeFeature, features } = useStoreState((state) => state.features);
  const setSkipVisible = useStoreActions(
    (actions) => actions.stage.setSkipVisible
  );
  const setCurrentIntervalEnd = useStoreActions(
    (actions) => actions.analytics.setCurrentIntervalEnd
  );
  const handleSkipClick = () => {
    setCurrentIntervalEnd(videoPlayer.currentTime());
    if (activeFeature >= 0 && activeFeature < features.length - 1) {
      videoPlayer.currentTime(getSeconds(features[activeFeature + 1].start));
    }
    if (activeFeature === features.length - 1) {
      videoPlayer.currentTime(videoPlayer.duration() - 1);
    }
    setSkipVisible(false);
  };
  return (
    <>
      <button
        type="button"
        className="demo__skip-btn"
        onClick={handleSkipClick}
      >
        <span className="visually-hidden">Skip</span>
      </button>
      <style jsx="true">
        {`
          #${containerId} .demo__skip-btn {
            top: ${mobileResponsiveUtil.getHeightValue(40)}px !important;
            right: ${mobileResponsiveUtil.getWidthValue(44)}px !important;
            height: ${mobileResponsiveUtil.getHeightValue(61)}px !important;
            width: ${mobileResponsiveUtil.getWidthValue(61)}px !important;
            position: absolute !important;
            z-index: 1 !important;
            display: ${isVisible ? "block" : "none"} !important;
            box-shadow: none !important;
            border: 0 !important;
            border-radius: 50% !important;
            background-color: transparent !important;
            background-image: none !important;
            background-repeat: no-repeat !important;
            background-size: cover !important;
          }

          #${containerId} .demo__skip-btn&:focus,
          #${containerId} .demo__skip-btn&:active {
            outline: 0 !important;
          }
        `}
      </style>
    </>
  );
}

SkipButton.propTypes = {
  containerId: PropTypes.string.isRequired,
  mobileResponsiveUtil: PropTypes.shape({
    getHeightValue: PropTypes.func,
    getWidthValue: PropTypes.func,
    getFontSize: PropTypes.func,
  }),
};

SkipButton.defaultProps = {
  mobileResponsiveUtil: {
    getHeightValue: () => {},
    getWidthValue: () => {},
    getFontSize: () => {},
  },
};

export default SkipButton;
